import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_ENDPOINTS, API_METHODS } from "../../constants/endpoints";
import { whitelabel_id } from "../../constants/ids";
import apiCall from "../../utils/apiCall";
import toastr from "toastr";
import { useLocation } from 'react-router-dom';
import moment from "moment";
import { useTheme } from "../../pages/Theme/themeContext";
import { cardBackground, cardBackground2, cardDarkBG, sideBarBG, textColor } from "../../pages/Theme/lightThemeStyles";
import NotificationsModal from "./notificationModal";


function DashboardLayout({ children, title }) {
  const location = useLocation();
  const navigate = useNavigate()
  const [authUser, setAuthUser] = useState(JSON.parse(localStorage.getItem("auth_user")) || {})
  const [statuses, setStatuses] = useState({ company_status: "0", director_status: "0", document_status: "0" })
  const [director_kyc, setDirector_kyc] = useState(null)
  const [resend, setResend] = useState(null)
  const [loading, setLoading] = useState(false)
  const [notifications, setNotifications] = useState([])
  const [config, setConfig] = useState({})
  const [faviconUrl, setFaviconUrl] = useState(null)
  const [userInactive, setUserInactive] = useState(false);
  const { lightTheme, toggleTheme } = useTheme();
  const [logo, setLogo] = useState('')
  const [darkLogo, setDarkLogo] = useState('')
  const [selectedNoti,setSelectedNoti]=useState('')
  useEffect(() => {
    let inactivityTimeout;

    const resetTimer = () => {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(handleInactive, 15 * 60 * 1000);
    };

    const handleInactive = async () => {
      if (authUser != {}) {
        setUserInactive(true);
        await logout()
        // localStorage.removeItem('auth_user')
        // sessionStorage.removeItem('auth_user')
        // window.location.reload()
      }
    };
    const handleActivity = () => {
      setUserInactive(false);
      resetTimer();
    };
    document.addEventListener('mousemove', handleActivity);
    document.addEventListener('keydown', handleActivity);
    resetTimer();

    return () => {
      clearTimeout(inactivityTimeout);
      document.removeEventListener('mousemove', handleActivity);
      document.removeEventListener('keydown', handleActivity);
    };
  }, []);

  useEffect(() => {

    const scriptUrls = [
      "js/custom.min.js",
      "js/dlabnav-init.js",
      // "vendor/pickadate/picker.js",
      // "vendor/pickadate/picker.time.js",
      // "vendor/pickadate/picker.date.js",
      // "js/plugins-init/pickadate-init.js",
      "vendor/bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker.js",
      // "js/plugins-init/material-date-picker-init.js",
      // "vendor/bootstrap-daterangepicker/daterangepicker.js",
      "vendor/moment/moment.min.js",
      "js/plugins-init/select2-init.js",
      "vendor/select2/js/select2.full.min.js",
      "vendor/toastr/js/toastr.min.js",
      "js/plugins-init/toastr-init.js"
      // "vendor/bootstrap-select/dist/js/bootstrap-select.min.js"
    ];

    scriptUrls.forEach((scriptUrl) => {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      document.body.appendChild(script);
    });
    // Load each script asynchronously

    return () => {
      // Clean up: Remove the script elements when the component unmounts
      scriptUrls.forEach((scriptUrl) => {
        const script = document.querySelector(`[src="${scriptUrl}"]`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);
  useEffect(() => {
    // Update the favicon dynamically
    const faviconLink = document.getElementById('favicon');
    if (faviconLink) {
      faviconLink.href = faviconUrl;
    }
  }, [faviconUrl]);
  useEffect(() => {
    if (authUser == {}) {
      return navigate('/login')
    }
    if (authUser?.is_live != 1) {
      getCompanyStatus()
    }
    if (authUser?.is_live == 1) {
      getNotifications()
    }
    getConfigSettings()
  }, [authUser])

  useEffect(() => {
    handleUserLive();
    const intervalId = setInterval(() => {
      handleUserLive();
    }, 30000);
    return () => clearInterval(intervalId);
  }, [location]);
  const getCompanyStatus = async () => {

    const { web_token, user_id } = authUser
    const url = API_ENDPOINTS.GET_COMPANY_STATUS
    const body = {
      whitelabel_id: whitelabel_id,
      web_token: web_token,
      user_id: user_id,
    }
    const response = await apiCall(url, API_METHODS.POST, body)
    if (response?.status == 1) {
      setStatuses((prevState) => ({
        ...prevState,
        company_status: response?.user?.company_status,
        director_status: response?.user?.director_status,
        document_status: response?.user?.document_status
      }))
      localStorage.setItem("statuses", JSON.stringify(statuses))
      // if (response?.user?.company_status != "2" || response?.user?.director_status != "2" || response?.user?.document_status !="2") {
      //   return navigate('/account-confirmation')
      // }
      toastr.success('company information fetched successfully.')
      setLoading(false)
    } else if (response?.status == 0) {
      console.error(response?.message)
      setLoading(false)

    } else {
      toastr.error('Unable to login.')
    }
  }
  const getNotifications = async () => {
    setLoading(true)
    const { web_token, user_id } = authUser
    const url = API_ENDPOINTS.GET_NOTIFICATIONS
    const body = {
      whitelabel_id: whitelabel_id,
      web_token: web_token,
      user_id: user_id,
    }
    const response = await apiCall(url, API_METHODS.POST, body)
    if (response?.status == 1) {
      setNotifications(response?.notifications)

      setLoading(false)
    } else if (response?.status == 0) {
      console.error(response?.message)
      setLoading(false)

    } else {
      console.error('Unable to fetch.')
    }
  }
  const getConfigSettings = async () => {
    setLoading(true)
    const url = API_ENDPOINTS.GET_CONFIG_SETTINGS
    const body = {
      whitelabel_id: whitelabel_id,
    }
    const response = await apiCall(url, API_METHODS.POST, body)
    if (response?.status == 1) {
      const data = JSON.stringify(response?.config)
      setConfig(response?.config)
      setFaviconUrl(response?.config?.site_favicon)
      setLogo(response?.config?.logo)
      setDarkLogo(response?.config?.dark_logo)
      setLoading(false)

    } else if (response?.status == 0) {
      console.error(response?.message)
      setLoading(false)

    } else {
      console.error('Unable to fetch.')
    }
  }

  const logout = async () => {
    const url = API_ENDPOINTS.LOGOUT
    const { web_token, user_id } = authUser
    const body = {
      whitelabel_id: whitelabel_id,
      web_token: web_token,
      user_id: user_id,
    }
    const response = await apiCall(url, API_METHODS.POST, body)
    if (response?.status == 1) {
      localStorage.removeItem('auth_user')
      sessionStorage.removeItem('auth_user')
      window.location.reload()
      setLoading(false)
    } else if (response?.status == 0) {
      console.error(response?.message)
      setLoading(false)

    } else {
      console.error('Unable to fetch.')
    }

    // navigate('/login')
  }
  const handleUserLive = async () => {
    const url = API_ENDPOINTS.UPDATE_USER_LIVE
    const { web_token, user_id } = authUser
    const body = {
      whitelabel_id: whitelabel_id,
      web_token: web_token,
      user_id: user_id,
    }
    const response = await apiCall(url, API_METHODS.POST, body)
    if (response?.status == 1) {
    } else if (response?.status == 0) {
      console.error(response?.message)
      // await logout()
    }
    else if (response?.status == 205) {

      localStorage.removeItem('auth_user')
      sessionStorage.removeItem('auth_user')
      window.location.reload()
      console.error(response?.message)

    }
    else {
      console.error('Unable to fetch.')
    }
  }


  const updateNotification = async (id)=>{
    setLoading(true)
    const { web_token, user_id } = authUser
    const url = API_ENDPOINTS.UPDATE_NOTIFICATION
    const body = {
      whitelabel_id: whitelabel_id,
      web_token: web_token,
      user_id: user_id,
      notification_id:id
    }
    const response = await apiCall(url, API_METHODS.POST, body)
    if (response?.status == 1) {
     getNotifications()

      setLoading(false)
    } else if (response?.status == 0) {
      console.error(response?.message)
      setLoading(false)

    } else {
      console.error(response?.message || 'Unable to update notification.')
    }
  }

  return (
    <div >
      {/********************
    Preloader start
      *********************/}
      <div id="preloader">
        <div className="inner">
          <span>Loading </span>
          <div className="loading"></div>
        </div>
      </div>
      {/********************
    Preloader end
      *********************/}
      {/***********************************
    Main wrapper start
      ************************************/}
      <div id="main-wrapper">
        <NotificationsModal notifications={notifications|| []} getNotifications={getNotifications} setSelectedNoti={setSelectedNoti}/>
        <div className={`animation `}>
          <span className="circle one" />
          <span className="circle two" />
          <span className="circle three" />
          {!lightTheme && <span className="circle four" />}
          <span className="line-1 ">
            <svg
              width={1920}
              height={450}
              viewBox="0 0 1920 450"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.3"
                d="M0 155L95.4613 293.923C106.459 309.928 131.116 305.943 136.512 287.289L209.86 33.7127C215.892 12.8576 244.803 11.2033 253.175 31.2341L344.838 250.546C352.224 268.217 376.708 269.648 386.102 252.958L519.839 15.3693C529.061 -1.01332 552.975 -0.0134089 560.797 17.0818L716.503 357.389C724.454 374.766 748.899 375.43 757.782 358.51L902.518 82.8223C911.524 65.6685 936.406 66.653 944.028 84.4648L1093.06 432.731C1101.14 451.601 1128.01 451.247 1135.58 432.172L1291.33 39.9854C1298.27 22.5135 1322.1 20.2931 1332.14 36.1824L1473.74 260.126C1482.47 273.922 1502.38 274.494 1511.88 261.221L1667.88 43.3025C1678.17 28.9257 1700.16 31.0533 1707.5 47.1365L1844.91 348.06C1853.69 367.287 1881.58 365.486 1887.81 345.29L1970 79"
                stroke={lightTheme ? "#CCCCCC" : "url(#paint0_linear_332_3757)"}
                strokeOpacity="0.4"
                strokeWidth={6}
                strokeLinecap="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_332_3757"
                  x1="1946.24"
                  y1="352.062"
                  x2="-1.52124"
                  y2="345.607"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset={0} stopColor="#6E4AFF" />
                  <stop offset="0.479167" stopColor="#E43BFF" />
                  <stop offset={1} stopColor="#6E4AFF" />
                </linearGradient>
              </defs>
            </svg>
          </span>
          <span className="line-2">
            <svg
              width={1920}
              height={459}
              viewBox="0 0 1920 459"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 89L103.191 296.201C112.034 313.958 137.703 312.941 145.114 294.54L224.847 96.5574C232.264 78.141 257.962 77.1423 266.786 94.9275L352.649 267.995C360.863 284.553 384.264 285.148 393.31 269.03L516.226 50.0159C525.164 34.0902 548.205 34.4325 556.666 50.6167L713.497 350.608C721.71 366.318 743.86 367.222 753.326 352.234L901.462 117.684C911.188 102.286 934.102 103.763 941.771 120.282L1091.14 442.062C1099.38 459.816 1124.62 459.817 1132.86 442.064L1303.17 75.2544C1310.64 59.1685 1332.73 57.2308 1342.89 71.7713L1469.94 253.703C1479.15 266.893 1498.71 266.794 1507.78 253.511L1671.82 13.4627C1681.74 -1.05968 1703.63 0.478486 1711.42 16.2459L1844.42 285.267C1853.64 303.905 1880.89 301.723 1887.02 281.857L1970 13"
                // stroke="url(#paint0_linear_332_3758)"
                stroke={lightTheme ? "#BDBDBD" : "url(#paint0_linear_332_3758)"}
                strokeOpacity="0.4"
                strokeWidth={6}
                strokeLinecap="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_332_3758"
                  x1="1946.24"
                  y1="286.062"
                  x2="-1.52105"
                  y2="279.607"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset={0} stopColor="#6E4AFF" />
                  <stop offset="0.479167" stopColor="#E43BFF" />
                  <stop offset={1} stopColor="#6E4AFF" />
                </linearGradient>
              </defs>
            </svg>
          </span>
        </div>
        {/***********************************
        Nav header start
    ************************************/}
        <div className="nav-header" >
          <a href="javascript:void(0)" className="brand-logo">
            <img className="logo-abbr mt-2 text-white image-container d-md-none d-block d-lg-block"
              src={lightTheme ? logo : darkLogo} alt="" />

          </a>
          <div className="nav-control d-lg-none " style={{ left: "80px", marginTop: '8px' }}>
            <div className="hamburger " >
              <span className="line" />
              <span className="line" />
              <span className="line" />
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M16.7548 0.333313H20.7051C22.341 0.333313 23.6667 1.67014 23.6667 3.31994V7.30359C23.6667 8.95339 22.341 10.2902 20.7051 10.2902H16.7548C15.1188 10.2902 13.7932 8.95339 13.7932 7.30359V3.31994C13.7932 1.67014 15.1188 0.333313 16.7548 0.333313Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.29492 0.333313H7.24522C8.8812 0.333313 10.2068 1.67014 10.2068 3.31994V7.30359C10.2068 8.95339 8.8812 10.2902 7.24522 10.2902H3.29492C1.65894 10.2902 0.333313 8.95339 0.333313 7.30359V3.31994C0.333313 1.67014 1.65894 0.333313 3.29492 0.333313ZM3.29492 13.7097H7.24522C8.8812 13.7097 10.2068 15.0466 10.2068 16.6964V20.68C10.2068 22.3287 8.8812 23.6666 7.24522 23.6666H3.29492C1.65894 23.6666 0.333313 22.3287 0.333313 20.68V16.6964C0.333313 15.0466 1.65894 13.7097 3.29492 13.7097ZM20.705 13.7097H16.7547C15.1188 13.7097 13.7931 15.0466 13.7931 16.6964V20.68C13.7931 22.3287 15.1188 23.6666 16.7547 23.6666H20.705C22.341 23.6666 23.6666 22.3287 23.6666 20.68V16.6964C23.6666 15.0466 22.341 13.7097 20.705 13.7097Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
        {/***********************************
        Nav header end
    ************************************/}
  
        {/***********************************
        Header start
    ************************************/}
        <div className="header" >
          <div className="header-content">
            <nav className="navbar navbar-expand">
              <div className="collapse navbar-collapse justify-content-between">
                <div className="header-left">
                  <div className="dashboard_bar" >{title}</div>
                </div>
                
                <div className="dropdown header-profile2 ">
                  <ul className="navbar-nav header-right me-sm-4">
                    <li className="nav-item dropdown notification_dropdown">
                      <a
                        className="nav-link"
                        href="javascript:void(0);"
                        role="button"
                        onClick={toggleTheme}

                      >
                        {!lightTheme ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sun" viewBox="0 0 16 16">
                          <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708" />
                        </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-moon" viewBox="0 0 16 16">
                          <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286" />
                        </svg>}
                      </a>
                    </li>
                    <li className="nav-item dropdown notification_dropdown">
                      <a
                        className="nav-link"
                        href="javascript:void(0);"
                        role="button"
                        data-bs-toggle="dropdown"

                      >
                        <svg
                          width={20}
                          height={21}
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.8333 11H17.5833C18.5498 11 19.3333 11.7835 19.3333 12.75C19.3333 13.7165 18.5498 14.5 17.5833 14.5H2.41666C1.45016 14.5 0.666656 13.7165 0.666656 12.75C0.666656 11.7835 1.45016 11 2.41666 11H4.16666L4.81798 5.13812C5.11136 2.49763 7.34325 0.5 9.99999 0.5C12.6567 0.5 14.8886 2.49763 15.182 5.13812L15.8333 11Z"
                            fill="#B9A8FF"
                          />
                          <path
                            opacity="0.3"
                            d="M12.3333 18C12.3333 16.7114 11.2887 15.6667 9.99999 15.6667C8.71133 15.6667 7.66666 16.7114 7.66666 18C7.66666 19.2887 8.71133 20.3334 9.99999 20.3334C11.2887 20.3334 12.3333 19.2887 12.3333 18Z"
                            fill="#B9A8FF"
                          />
                        </svg>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <div
                          id="DZ_W_Notification1"
                          className="widget-media dz-scroll p-3"
                          style={{ height: 380 }}
                        >
                          <ul className="timeline">

                            {notifications?.length > 0 ? notifications?.map((noti) => {
                              return <li>
                                <div className="timeline-panel"  style={{cursor:'pointer'}}
                                data-bs-toggle="modal" data-bs-target="#notification"
                                 onClick={()=>{setSelectedNoti(noti);updateNotification(noti?.id)}}>
                                  <div className="media me-2 media-info" style={{background:lightTheme?'#CFCFCF99':'#5E3ED099'}}><svg
                          width={20}
                          height={21}
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.8333 11H17.5833C18.5498 11 19.3333 11.7835 19.3333 12.75C19.3333 13.7165 18.5498 14.5 17.5833 14.5H2.41666C1.45016 14.5 0.666656 13.7165 0.666656 12.75C0.666656 11.7835 1.45016 11 2.41666 11H4.16666L4.81798 5.13812C5.11136 2.49763 7.34325 0.5 9.99999 0.5C12.6567 0.5 14.8886 2.49763 15.182 5.13812L15.8333 11Z"
                            fill="#B9A8FF"
                          />
                          <path
                            opacity="0.3"
                            d="M12.3333 18C12.3333 16.7114 11.2887 15.6667 9.99999 15.6667C8.71133 15.6667 7.66666 16.7114 7.66666 18C7.66666 19.2887 8.71133 20.3334 9.99999 20.3334C11.2887 20.3334 12.3333 19.2887 12.3333 18Z"
                            fill="#B9A8FF"
                          />
                        </svg></div>
                                  <div className="media-body">
                                    <h6 className="mb-1">
                                      <a href="javascript:voiud(0)">
                                        {noti?.description}
                                      </a>
                                    </h6>
                                    <small className="d-block">
                                      {moment(noti?.date).format("DD MMM YYYY - hh:mm A")}
                                    </small>
                                  </div>
                                </div>
                              </li>
                            }) : <li>No Notifications</li>}

                          </ul>
                        </div>
                        <a
                          className="all-notification"
                          href="javascript:void(0);"
                          data-bs-toggle="modal" data-bs-target="#allNotifications"
                        >
                          See all notifications <i className="ti-arrow-end" />
                        </a>
                      </div>
                    </li>
                    
                    
                  </ul>
                  <a
                    className="nav-link user-profile"
                    href="javascript:void(0);"
                    role="button"
                    data-bs-toggle="dropdown"

                  >
                    <div className="header-info2 d-flex align-items-center">
                      <img src={require('../../assets/user-default-image.png')} alt="" />
                      <div className="d-flex align-items-center sidebar-info">
                        <div className="user-info" >
                          <span className={`font-w500 d-block  fs-5 text-white`} >
                            {authUser?.company_name}
                          </span>
                          <small className="text-end font-w400" >Admin</small>
                        </div>
                        <svg
                          width={14}
                          height={8}
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.8334 1.08331L7.00002 6.91665L1.16669 1.08331"
                            stroke="#FFFF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </a>
                  <div className="dropdown-menu profile dropdown-menu-end">
                    <Link
                      to={"/profile"}
                      className="dropdown-item ai-icon "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-primary"
                        width={18}
                        height={18}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx={12} cy={7} r={4} />
                      </svg>
                      <span className="ms-2">Profile </span>
                    </Link>
                   
                    <a href="javascript:void(0)" onClick={logout} className="dropdown-item ai-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-danger"
                        width={18}
                        height={18}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1={21} y1={12} x2={9} y2={12} />
                      </svg>
                      <span className="ms-2">Logout </span>
                    </a>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
        {/***********************************
        Header end ti-comment-alt
    ************************************/}
        {/***********************************
        Sidebar start
    ************************************/}
        <div className="dlabnav ">
          <div className="dlabnav-scroll" >
            <ul className="metismenu" id="menu">

              {/* dashboard codego */}
              {(authUser && authUser.is_live == 1) &&
                // statuses.company_status == "2" && 
                <li className={`${(location?.pathname == "/balance" || location?.pathname == "/") ? 'mm-active' : ''}`}>
                  <Link to={"/balance"} className={`${location?.pathname == "/balance" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text">Balance</span>
                  </Link>
                </li>}
              {(authUser && authUser.is_live == 1) &&
                // statuses.company_status == "2" && 
                <li className={`${location?.pathname == "/transactions-history" ? 'mm-active' : ''}`}>
                  <Link to={"/transactions-history"} className={`${location?.pathname == "/transactions-history" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text" >Transaction History</span>
                  </Link>
                </li>}
              {(authUser && authUser.is_live == 1) &&
                // statuses.company_status == "2" && 
                <li className={`${location?.pathname == "/pos-transactions-history" ? 'mm-active' : ''}`}>
                  <Link to={"/pos-transactions-history"} className={`${location?.pathname == "/pos-transactions-history" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text">POS Transaction History</span>
                  </Link>
                </li>}
              {(authUser && authUser.is_live == 1) &&
                <li className={`${location?.pathname == "/pos-payment-history" ? 'mm-active' : ''}`}>
                  <Link to={"/pos-payment-history"} className={`${location?.pathname == "/pos-payment-history" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text">POS Payment History</span>
                  </Link>
                </li>}
              {(authUser && authUser.is_live == 1) &&
                // statuses.company_status == "2" && 
                <li className={`${location?.pathname == "/crypto-currency" ? 'mm-active' : ''}`}>
                  <Link to={"/crypto-currency"} className={`${location?.pathname == "/crypto-currency" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text">Crypto</span>
                  </Link>
                </li>}
             
              {/* Beneficiaries start*/}
              {(authUser && authUser.is_live == 1) &&
                <li>
                  <a
                    className="has-arrow "
                    href="javascript:void()"
                    aria-expanded="false"
                  >
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.34933 14.8577C5.38553 14.8577 2 15.47 2 17.9174C2 20.3666 5.364 21 9.34933 21C13.3131 21 16.6987 20.3877 16.6987 17.9404C16.6987 15.4911 13.3347 14.8577 9.34933 14.8577Z"
                          fill="#B9A8FF"
                        />
                        <path
                          opacity="0.4"
                          d="M9.34935 12.5248C12.049 12.5248 14.2124 10.4062 14.2124 7.76241C14.2124 5.11865 12.049 3 9.34935 3C6.65072 3 4.48633 5.11865 4.48633 7.76241C4.48633 10.4062 6.65072 12.5248 9.34935 12.5248Z"
                          fill="#763ed0"
                        />
                        <path
                          opacity="0.4"
                          d="M16.1734 7.84875C16.1734 9.19507 15.7605 10.4513 15.0364 11.4948C14.9611 11.6021 15.0276 11.7468 15.1587 11.7698C15.3407 11.7995 15.5276 11.8177 15.7184 11.8216C17.6167 11.8704 19.3202 10.6736 19.7908 8.87118C20.4885 6.19676 18.4415 3.79543 15.8339 3.79543C15.5511 3.79543 15.2801 3.82418 15.0159 3.87688C14.9797 3.88454 14.9405 3.90179 14.921 3.93246C14.8955 3.97174 14.9141 4.02253 14.9395 4.05607C15.7233 5.13216 16.1734 6.44207 16.1734 7.84875Z"
                          fill="#763ed0"
                        />
                        <path
                          d="M21.7791 15.1693C21.4317 14.444 20.5932 13.9466 19.3172 13.7023C18.7155 13.5586 17.0853 13.3545 15.5697 13.3832C15.5472 13.3861 15.5344 13.4014 15.5325 13.411C15.5295 13.4263 15.5364 13.4493 15.5658 13.4656C16.2663 13.8048 18.9738 15.2805 18.6333 18.3928C18.6186 18.5289 18.7292 18.6439 18.8671 18.6247C19.5335 18.5318 21.2478 18.1705 21.7791 17.0475C22.0736 16.4534 22.0736 15.7635 21.7791 15.1693Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text" >Beneficiaries</span>
                  </a>
                  <ul aria-expanded="false">

                    <li >
                      <Link to={"/beneficiaries"} className={`${location?.pathname == '/beneficiaries' ? 'active text-white' : 'inactive'}`} >Beneficiaries</Link>
                    </li>

                    <li >
                      <Link to={"/add-beneficiary"} className={`${location?.pathname == '/add-beneficiary' ? 'active text-white' : 'inactive'}`} >Add Beneficiary</Link>
                    </li>
                  </ul>
                </li>}
              
              {/* Beneficiaries end */}
              {/* company start*/}
              {(authUser && authUser.is_live != 1) && <li>
                <a
                  className="has-arrow "
                  href="javascript:void()"
                  aria-expanded="false"
                >
                  <div className="menu-icon">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="IconlyHome">
                        <g id="Home">
                          <path
                            id="Home_2"
                            d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z"
                            fill="#130F26"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <span className="nav-text">Company</span>
                </a>
                <ul aria-expanded="false">
                  {/* <li>
                    <Link to={"/company-profile"} className={`${location?.pathname == '/company-profile' ? 'active text-white' : 'inactive'}`}>Company Profile</Link>
                  </li>
                  <li>
                    <Link to={"/company-board-members"} className={`${location?.pathname == '/company-board-members' ? 'active text-white' : 'inactive'}`}>Company Director</Link>
                  </li>
                  <li>
                    <Link to={"/company-share-holders"} className={`${location?.pathname == '/company-share-holders' ? 'active text-white' : 'inactive'}`}>Share Holders</Link>
                  </li>
                  <li>
                    <Link to={"/company-share-holders-list"} className={`${location?.pathname == '/company-share-holders-list' ? 'active text-white' : 'inactive'}`}>Share Holders List</Link>
                  </li>
                  <li>
                    <Link to={"/corporate-documents"} className={`${location?.pathname == '/corporate-documents' ? 'active text-white' : 'inactive'}`}>Corporate Documents</Link>
                  </li> */}
                  <li>
                    <Link to={"/account-confirmation"} className={`${location?.pathname == '/account-confirmation' ? 'active text-white' : 'inactive'}`}>Dashboard</Link>
                  </li>

                </ul>
              </li>}
              {/* company */}
              
              
              
              
             
              {(authUser && authUser.is_live == 1) &&
                // statuses.company_status == "2" && 
                <li className={`${location?.pathname == "/profile" ? 'mm-active' : ''}`}>
                  <Link to={"/profile"} className={`${location?.pathname == "/profile" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text" >Profile</span>
                  </Link>
                </li>}
              {(authUser && authUser.is_live == 1) &&
                // statuses.company_status == "2" && 
                <li className={`${location?.pathname == "/plans" ? 'mm-active' : ''}`}>

                  <Link to={"/plans"} className={`${location?.pathname == "/plans" ? 'active text-white' : 'inactive'}`} aria-expanded="false">
                    <div className="menu-icon">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.4"
                          d="M16.0754 2H19.4614C20.8636 2 21.9999 3.14585 21.9999 4.55996V7.97452C21.9999 9.38864 20.8636 10.5345 19.4614 10.5345H16.0754C14.6731 10.5345 13.5369 9.38864 13.5369 7.97452V4.55996C13.5369 3.14585 14.6731 2 16.0754 2Z"
                          fill="#763ed0"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                          fill="#B9A8FF"
                        />
                      </svg>
                    </div>
                    <span className="nav-text" >Plans</span>
                  </Link>
                </li>}
              
              
            </ul>
            <div className="copyright">
              <p className="fs-14" >
                <strong >{config?.site_name} Business Banking</strong>
                {/* © 2023 All Rights Reserved */}
                {config?.copy_right_text}
              </p>
              {/* <p className="fs-14">
                Made with <span className="heart" /> by DexignZone
              </p> */}
            </div>
          </div>
        </div>

{/* Notification Modal */}
<div class="modal fade" id="notification">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Notification</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" >
                        </button>
                    </div>
                     <div class="modal-body">



                      
                      <div>
                        <h3>{selectedNoti?.title}</h3>
                        <small> {moment(selectedNoti?.date).format("DD MMM YYYY - hh:mm A")}</small><br/>
                        <span>{selectedNoti?.description}</span>
                      </div>



                    </div> 

                </div>
            </div>
        </div>
{/* Notification Modal */}
        <div className="content-body">
          {/* row */}
          <div className="container-fluid">{children}</div>
        </div>
        <div class="footer out-footer" >
          <div class="copyright">
            <p >
              Copyright © Designed & Developed by
              {/* Copyright © Designed &amp; Developed by{" "} */}
              <a href="https://codegotech.com/" target="_blank">
                {" "}
                Codegotech
              </a>{" "}
              2024
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DashboardLayout;


{/* <div className="logo"> */ }
{/* <h2 className="brand-title " style={{ fontWeight: 'bold', marginBottom: '2px' }}>CODEGO</h2> */ }
{/* <svg
                className="brand-title"
                width={124}
                height={33}
                viewBox="0 0 132 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.65 2.516C14.758 2.516 17.474 3.132 19.798 4.364C22.122 5.596 23.914 7.332 25.174 9.572C26.462 11.784 27.106 14.346 27.106 17.258C27.106 20.142 26.462 22.704 25.174 24.944C23.914 27.184 22.108 28.92 19.756 30.152C17.432 31.384 14.73 32 11.65 32H0.604V2.516H11.65ZM11.188 25.784C13.904 25.784 16.018 25.042 17.53 23.558C19.042 22.074 19.798 19.974 19.798 17.258C19.798 14.542 19.042 12.428 17.53 10.916C16.018 9.404 13.904 8.648 11.188 8.648H7.786V25.784H11.188ZM41.7876 32.336C39.4916 32.336 37.4196 31.846 35.5716 30.866C33.7516 29.886 32.3096 28.486 31.2456 26.666C30.2096 24.846 29.6916 22.718 29.6916 20.282C29.6916 17.874 30.2236 15.76 31.2876 13.94C32.3516 12.092 33.8076 10.678 35.6556 9.698C37.5036 8.718 39.5756 8.228 41.8716 8.228C44.1676 8.228 46.2396 8.718 48.0876 9.698C49.9356 10.678 51.3916 12.092 52.4556 13.94C53.5196 15.76 54.0516 17.874 54.0516 20.282C54.0516 22.69 53.5056 24.818 52.4136 26.666C51.3496 28.486 49.8796 29.886 48.0036 30.866C46.1556 31.846 44.0836 32.336 41.7876 32.336ZM41.7876 26.12C43.1596 26.12 44.3216 25.616 45.2736 24.608C46.2536 23.6 46.7436 22.158 46.7436 20.282C46.7436 18.406 46.2676 16.964 45.3156 15.956C44.3916 14.948 43.2436 14.444 41.8716 14.444C40.4716 14.444 39.3096 14.948 38.3856 15.956C37.4616 16.936 36.9996 18.378 36.9996 20.282C36.9996 22.158 37.4476 23.6 38.3436 24.608C39.2676 25.616 40.4156 26.12 41.7876 26.12ZM65.0438 26.456H74.4518V32H57.8618V2.516H65.0438V26.456ZM76.4494 20.24C76.4494 17.832 76.8974 15.718 77.7934 13.898C78.7174 12.078 79.9634 10.678 81.5314 9.698C83.0994 8.718 84.8494 8.228 86.7814 8.228C88.4334 8.228 89.8754 8.564 91.1074 9.236C92.3674 9.908 93.3334 10.79 94.0054 11.882V8.564H101.187V32H94.0054V28.682C93.3054 29.774 92.3254 30.656 91.0654 31.328C89.8334 32 88.3914 32.336 86.7394 32.336C84.8354 32.336 83.0994 31.846 81.5314 30.866C79.9634 29.858 78.7174 28.444 77.7934 26.624C76.8974 24.776 76.4494 22.648 76.4494 20.24ZM94.0054 20.282C94.0054 18.49 93.5014 17.076 92.4934 16.04C91.5134 15.004 90.3094 14.486 88.8814 14.486C87.4534 14.486 86.2354 15.004 85.2274 16.04C84.2474 17.048 83.7574 18.448 83.7574 20.24C83.7574 22.032 84.2474 23.46 85.2274 24.524C86.2354 25.56 87.4534 26.078 88.8814 26.078C90.3094 26.078 91.5134 25.56 92.4934 24.524C93.5014 23.488 94.0054 22.074 94.0054 20.282ZM113.565 11.882C114.237 10.79 115.203 9.908 116.463 9.236C117.723 8.564 119.165 8.228 120.789 8.228C122.721 8.228 124.471 8.718 126.039 9.698C127.607 10.678 128.839 12.078 129.735 13.898C130.659 15.718 131.121 17.832 131.121 20.24C131.121 22.648 130.659 24.776 129.735 26.624C128.839 28.444 127.607 29.858 126.039 30.866C124.471 31.846 122.721 32.336 120.789 32.336C119.137 32.336 117.695 32.014 116.463 31.37C115.231 30.698 114.265 29.816 113.565 28.724V32H106.383V0.92H113.565V11.882ZM123.813 20.24C123.813 18.448 123.309 17.048 122.301 16.04C121.321 15.004 120.103 14.486 118.647 14.486C117.219 14.486 116.001 15.004 114.993 16.04C114.013 17.076 113.523 18.49 113.523 20.282C113.523 22.074 114.013 23.488 114.993 24.524C116.001 25.56 117.219 26.078 118.647 26.078C120.075 26.078 121.293 25.56 122.301 24.524C123.309 23.46 123.813 22.032 123.813 20.24Z"
                  fill="white"
                />
              </svg> */}
{/* <h2 className="brand-title text-white">CODEGO</h2> */ }
{/* <img className="logo-abbr text-white mt-1"
                src={logo} alt="n/a" /> */}
{/* <svg
                className="logo-abbr"
                width={43}
                height={34}
                viewBox="0 0 43 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="22.6154"
                  width="19.6154"
                  height="6.53846"
                  rx="3.26923"
                  fill="white"
                />
                <rect
                  x="22.6154"
                  y="9.15387"
                  width="19.6154"
                  height="6.53846"
                  rx="3.26923"
                  fill="white"
                />
                <rect
                  x="22.6154"
                  y="18.3077"
                  width="19.6154"
                  height="6.53846"
                  rx="3.26923"
                  fill="white"
                />
                <rect
                  x="0.384583"
                  y="18.3077"
                  width="19.6154"
                  height="6.53846"
                  rx="3.26923"
                  fill="white"
                />
                <rect
                  x="22.6154"
                  y="27.4615"
                  width="19.6154"
                  height="6.53846"
                  rx="3.26923"
                  fill="white"
                />
                <rect
                  x="0.384583"
                  y="27.4615"
                  width="19.6154"
                  height="6.53846"
                  rx="3.26923"
                  fill="white"
                />
              </svg> */}

{/* </div> */ }